/* =============================================================================
   app.js — Interfaz del sitio
   Menú, navegación entre páginas, revelado al hacer scroll,
   formulario de reservas y marcador para las fotos que aún faltan.
   ============================================================================= */

// Número real del hotel: mismo que usan los links directos de wa.me de
// Experiencias y de los botones flotante/CTA del sitio.
const WA_NUMBER = '51974330699';

/* ── Preloader ──
   Se ve en TODA carga o recarga del sitio, no solo la primera vez (a
   propósito no mira sessionStorage). Desde 2026-10-13 está apagado (ver
   el <script> en línea tras #preloader) y cada sección es una página
   propia, así que ya no hay cambios de página internos. Con
   prefers-reduced-motion, el <script> inline del <head> del body ya marcó
   <html class="no-preload"> antes de que esto corriera — acá solo hace
   falta sacar el nodo del DOM y no volver a tocarlo nunca. */
const preEl = document.getElementById('preloader');
const shellEl = document.getElementById('app-shell');
const preloaderEnabled = !!preEl && !document.documentElement.classList.contains('no-preload');
if(!preloaderEnabled && preEl) preEl.remove();

function hidePreloader(){
  if(preloaderEnabled) preEl.classList.add('hide'); // .7s de fundido, ver CSS
}

// Primera pintura: la marca se ve al menos MIN ms desde que empezó la
// navegación (no desde que corre app.js, que llega tarde en equipos lentos: así
// el mínimo no se suma a la espera de los scripts) y con el DOM y el hero de la
// página activa listos. Una foto secundaria o una fuente pendiente no retienen
// el preloader. Techo de 4s si el hero no responde: el hero de entrada se pide
// desde el <head> con prioridad alta, así que no hace falta más margen.
if(preloaderEnabled){
  shellEl.classList.add('pre-reveal');
  const MIN=600, MAX=4000;
  let done=false;
  const revealFirstLoad=()=>{
    if(done) return;
    done=true;
    const salir=()=>{
      hidePreloader();
      shellEl.classList.remove('pre-reveal'); // scale(1.03) → scale(1) en sincro con el fundido del overlay
    };
    // El jardín del preloader retrae su vegetación y llama a `salir` durante
    // esa salida. El jardín de la página se construye después del fundido.
    // Sin ese módulo (o con movimiento reducido) se revela directamente.
    if(window.PreloaderJardin) window.PreloaderJardin.salir(salir); else salir();
  };
  const armWhenReady=()=>setTimeout(revealFirstLoad, Math.max(0, MIN-performance.now()));
  const domReady = new Promise(res=>{
    if(document.readyState!=='loading') return res();
    document.addEventListener('DOMContentLoaded', res, {once:true});
  });
  // Se consulta tras la inicialización síncrona de la navegación: un enlace
  // directo a otra página tiene que esperar SU hero, no el de Inicio.
  const heroReady = domReady.then(()=>new Promise(res=>{
    const heroImg = document.querySelector('.page.active .hero-media img');
    if(!heroImg || heroImg.complete) return res();
    heroImg.addEventListener('load', res, {once:true});
    heroImg.addEventListener('error', res, {once:true});
  }));
  // El techo cuenta desde la navegación, igual que el mínimo.
  Promise.race([
    heroReady,
    new Promise(res=>setTimeout(res, Math.max(0, MAX-performance.now()))),
  ]).then(armWhenReady);
}

const burger=document.getElementById('burger'), menu=document.getElementById('menu');
let menuOpen=false, scrollLockY=0;

/* Bug real en mobile: .menu es position:fixed, pero eso NO bloquea el
   scroll del documento de fondo (el dedo sigue moviendo la página detrás
   del panel). La solución robusta cross-browser (incluido el rebote de
   iOS Safari, donde un simple overflow:hidden en <body> no alcanza) es
   sacar el <body> del flujo de scroll con position:fixed y devolverlo a
   su scrollY exacto al cerrar — si solo se reseteara a 0 al cerrar, la
   página "saltaría" al inicio cada vez que se abre el menú. */
function setMenuOpen(open){
  menuOpen=open;
  burger.classList.toggle('open',open);
  burger.setAttribute('aria-expanded', open ? 'true' : 'false');   // el botón vive en la barra inferior del marco
  menu.classList.toggle('open',open);
  if(open){
    scrollLockY = window.scrollY;
    document.body.classList.add('menu-lock');
    document.body.style.top = (-scrollLockY)+'px';
  } else {
    document.body.classList.remove('menu-lock');
    document.body.style.top = '';
    // behavior:'instant', no el default: <html> tiene scroll-behavior:smooth
    // (ver site.css) y sin esto el restore se vería como un scroll animado
    // de vuelta en vez de un salto invisible al punto exacto de antes.
    window.scrollTo({ top: scrollLockY, left: 0, behavior: 'instant' });
  }
}
burger.addEventListener('click',()=>{ setMenuOpen(!menuOpen); });
// Esc cierra el panel. Y si la ventana pasa a escritorio con el panel abierto
// (girar una tablet, redimensionar), se cierra: en escritorio el menú es el
// del header y el panel no existe, así que el bloqueo de scroll quedaría puesto.
document.addEventListener('keydown',e=>{ if(e.key==='Escape' && menuOpen){ setMenuOpen(false); burger.focus(); } });
window.addEventListener('resize',()=>{ if(menuOpen && matchMedia('(min-width: 901px)').matches) setMenuOpen(false); },{passive:true});

// NAVEGACIÓN ENTRE PÁGINAS (2026-10-13). Cada sección es un documento propio
// con su URL, y cada idioma tiene las suyas (/habitaciones/, /en/rooms/…):
// así existen para buscadores y agentes de IA, y cada página carga sólo lo
// suyo. Los enlaces [data-page] ya traen su href real en el idioma de la
// página; aquí sólo se cierra el menú antes de salir. El fundido entre
// páginas lo hace el navegador (View Transitions, "Navegación" en site.css).
const current = (document.querySelector('.page.active')?.id || 'page-home').slice(5);
document.addEventListener('click', e=>{
  const el = e.target.closest('a[data-page]');
  // Ctrl/Cmd/Mayús o botón del medio: el navegador abre otra pestaña con el href.
  if(!el || e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if(menuOpen) setMenuOpen(false);
  if(el.dataset.page===current){ e.preventDefault(); return; }
});

// Título de la pestaña según página e idioma (meta.* en i18n.js).
function tituloPagina(){
  if(!window.I18N) return;
  document.title = current==='home'
    ? I18N.t('meta.title')
    : I18N.t('meta.page').replace('{page}', I18N.t('menu.nav.'+current));
}
tituloPagina();
document.addEventListener('i18n:change', tituloPagina);

const REDUCED_MOTION = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── Revelado de texto: títulos por palabra + párrafos en bloque ──
   [data-reveal="words"] trae su texto normal (con <em>/<br> incluidos si los
   tiene) en el HTML; acá se envuelve cada palabra en .rw > .rw-in una sola
   vez (dataset.split lo marca para no reprocesar en cada cambio de página).
   La recursión conserva las etiquetas inline (por eso <em> sigue en cursiva
   y <br> sigue partiendo línea) — un innerHTML=textContent las habría
   perdido. */
function splitWords(node){
  Array.from(node.childNodes).forEach(child=>{
    if(child.nodeType===Node.TEXT_NODE){
      if(!child.textContent.trim()) return;
      const frag=document.createDocumentFragment();
      child.textContent.split(/(\s+)/).forEach(part=>{
        if(part==='') return;
        if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
        const outer=document.createElement('span'); outer.className='rw';
        const inner=document.createElement('span'); inner.className='rw-in'; inner.textContent=part;
        outer.appendChild(inner); frag.appendChild(outer);
      });
      child.replaceWith(frag);
    } else if(child.nodeType===Node.ELEMENT_NODE && child.tagName!=='BR'){
      splitWords(child);
    }
  });
}
if(!REDUCED_MOTION){
  document.querySelectorAll('[data-reveal="words"]').forEach(el=>{
    if(el.dataset.split) return;
    el.dataset.split='1';
    splitWords(el);
  });
}

function reAnim(page){
  document.querySelectorAll('#page-'+page+' .hw').forEach((el,i)=>{ el.style.animation='none'; el.offsetHeight; el.style.animation=''; el.style.animationDelay=(0.35+i*.15)+'s'; });
  document.querySelectorAll('#page-'+page+' .rv-el').forEach(el=>el.classList.remove('on'));
  document.querySelectorAll('#page-'+page+' .rw-in').forEach(el=>{ el.classList.remove('on'); el.style.transitionDelay=''; });
  document.querySelectorAll('#page-'+page+' [data-reveal="fade"]').forEach(el=>el.classList.remove('on'));
  setTimeout(obs,80);
}
// Observers de la generación en curso. obs() se llama en CADA navegación (vía
// reAnim), y hasta aquí cada llamada creaba tres observers nuevos sin soltar
// los anteriores. Sí hay unobserve() al disparar, pero un elemento que nunca
// llega a entrar en pantalla —porque te fuiste de esa sección sin bajar hasta
// él— jamás lo dispara, así que su observer quedaba vivo indefinidamente.
//
// Medido en cuatro vueltas del circuito completo de 5 secciones:
//   observers creados   3 → 18 → 33 → 48 → 63
//   observers con targets  3 → 10 → 17 → 24 → 31
//   targets vivos      19 → 60 → 101 → 142 → 183
// Lineal y sin techo: +15 creados y +41 targets por vuelta, cero disconnect.
//
// No cambia nada visible: se observan los mismos elementos, con los mismos
// umbrales y las mismas clases. Lo único que cambia es que la generación
// anterior se suelta antes de crear la siguiente.
let observadores = [];

function obs(){
  observadores.forEach(ob => ob.disconnect());
  observadores = [];

  const o=new IntersectionObserver(en=>{ en.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('on'); o.unobserve(e.target);} }); },{threshold:.12});
  observadores.push(o);
  document.querySelectorAll('.page.active .rv-el').forEach(el=>o.observe(el));

  // Bajo reducción de movimiento no se registran los observadores de abajo
  // (palabras y [data-reveal="fade"]): el bloque reduced-motion de site.css
  // ya les deja opacity:1 y transform:none, así que observarlos no aportaría
  // nada. El observador de .rv-el de arriba SÍ queda activo a propósito: le
  // sigue añadiendo .on, y es el CSS —no este return— el que le quita el
  // desplazamiento. Hasta la Ronda 24 ese bloque no incluía .rv-el y el
  // comentario que había aquí daba por cubierto algo que no lo estaba.
  if(REDUCED_MOTION) return;

  // Palabras: 40ms de diferencia entre una y la siguiente (transitionDelay
  // por índice), y una sola vez por visita a la página — igual criterio que
  // .rv-el arriba: unobserve() al disparar, reset en reAnim() al volver.
  const wo=new IntersectionObserver(en=>{ en.forEach(e=>{
    if(!e.isIntersecting) return;
    e.target.querySelectorAll('.rw-in').forEach((span,i)=>{ span.style.transitionDelay=(i*40)+'ms'; span.classList.add('on'); });
    wo.unobserve(e.target);
  }); },{threshold:.2});
  observadores.push(wo);
  document.querySelectorAll('.page.active [data-reveal="words"]').forEach(el=>wo.observe(el));

  const fo=new IntersectionObserver(en=>{ en.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('on'); fo.unobserve(e.target);} }); },{threshold:.2});
  observadores.push(fo);
  document.querySelectorAll('.page.active [data-reveal="fade"]').forEach(el=>fo.observe(el));
}
obs(); // ya observa la página correcta: el swap por hash de arriba ya ocurrió

const navEl=document.getElementById('nav');
// La barra es blanca sobre la foto oscura del hero y se oscurece al pasarla.
// Si alguna página no trae `.hero` (ninguna la tiene hoy, pero la extinta
// página de Ubicación tampoco lo tenía — ver ARQUITECTURA.md), arranca ya
// oscura desde el principio en vez de blanca sobre fondo claro ilegible.
let navPage='', navHero=null, navLimit=0, navDarkZones=[];
function docY(el){ let y=0; for(let n=el; n; n=n.offsetParent) y+=n.offsetTop; return y; }
function navMeasure(){
  navPage=current;
  // Página actual en el menú del header (aria-current alimenta el subrayado).
  document.querySelectorAll('.hdr-nav a[data-page], .hdr-book[data-page], .bar-book[data-page]').forEach(a=>{
    if(a.dataset.page===current) a.setAttribute('aria-current','page'); else a.removeAttribute('aria-current');
  });
  // Secciones de fondo oscuro (telón de cierre y los tonos de noche de
  // Inicio, marcados con data-nav="oscuro"; el itinerario de Experiencias ya
  // es claro y usa la barra de papel como el resto): sobre ellas
  // el nav usa su versión clara —la misma que sobre la foto del hero— en vez
  // de la barra de papel.
  const navH=navEl.offsetHeight;
  navDarkZones=[...document.querySelectorAll('#page-'+current+' .curtain, #page-'+current+' [data-nav="oscuro"]')]
    .map(el=>{ const t=docY(el); return [t-navH, t+el.offsetHeight-navH]; });
  navHero=document.querySelector('#page-'+current+' .hero');
  if(!navHero){ navLimit=0; return; }

  // offsetTop/offsetHeight son medidas de layout: no incluyen el scale(1.03)
  // temporal del preloader. Se acumula la cadena de offsetParent para obtener
  // una coordenada documental aunque el hero deje de empezar en y=0.
  // En Inicio el hero se disuelve en niebla clara (T1 en scroll-fx.js): el logo
  // blanco quedaría ilegible antes de que el hero termine, así que el nav pasa
  // a su versión de papel al 55 % del hero y no al 100 %.
  const fraccion = current==='home' ? 0.55 : 1;
  navLimit=docY(navHero)+navHero.offsetHeight*fraccion-navH;
}
function navColor(){
  if(navPage!==current) navMeasure();
  const y = window.scrollY;
  const overHero = !!navHero && y <= navLimit;
  const overDark = navDarkZones.some(z => y >= z[0] && y <= z[1]);
  navEl.classList.toggle('dark', !(overHero || overDark));
}
// Pasivo: navColor solo lee scrollY y conmuta una clase, nunca llama a
// preventDefault. Declararlo le ahorra al navegador tener que esperar a que
// este manejador termine antes de desplazar.
window.addEventListener('scroll',navColor,{passive:true});
window.addEventListener('resize',()=>{ navMeasure(); navColor(); },{passive:true});
navColor(); // por si la carga inicial ya abrió, vía hash, una página sin hero

/* ── Carga de Leaflet bajo demanda ──
   Antes vivía en <head> y se descargaba en las 5 páginas aunque solo la
   miniatura del menú lo usa (~164KB de biblioteca + tiles que nadie más
   pide). Se inyecta la primera vez que se abre el menú, memoizado para no
   repetirlo si el visitante lo abre y cierra varias veces.
   El <link> de Leaflet se inserta ANTES que site.css en el <head> (no al
   final): site.css sobrescribe el estilo del marcador y los controles, y
   esa cascada depende de que Leaflet cargue primero — insertarlo después
   invertiría el orden y esos estilos dejarían de aplicar. */
let leafletReady = null;
function loadLeaflet(){
  if(window.L) return Promise.resolve();
  if(leafletReady) return leafletReady;
  leafletReady = new Promise((resolve, reject) => {
    // La hoja del sitio es el paquete minificado (id="css-sitio",
    // scripts/empaquetar.mjs) o, sin empaquetar, site.css con ?v=<hash>.
    // Leaflet se inyecta desde aquí, así que no lo versiona el script: lleva
    // su número de versión, y hay que cambiarlo al actualizar la librería
    // (la caché es de un año, ver .htaccess).
    const LEAFLET_V = '1.9.4';
    const siteCss = document.getElementById('css-sitio') || document.querySelector('link[href^="/assets/css/site.css"]');
    const css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = '/assets/vendor/leaflet/leaflet.css?v=' + LEAFLET_V;
    if (siteCss) siteCss.parentNode.insertBefore(css, siteCss); else document.head.appendChild(css);
    const script = document.createElement('script');
    script.src = '/assets/vendor/leaflet/leaflet.js?v=' + LEAFLET_V;
    script.onload = resolve; script.onerror = reject;
    document.head.appendChild(script);
  });
  return leafletReady;
}
/* Mapa grande de Inicio: se carga bajo demanda recién cuando la sección
   entra en viewport (a diferencia del héroe, no hace falta tenerlo listo
   desde el primer frame), no al abrir el menú como su miniatura — mismo
   motivo de siempre, no pagar el peso de Leaflet si nunca se llega a ver. */
const homeMapSec = document.querySelector('.home-map');
if (homeMapSec) {
  const io = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      loadLeaflet().then(() => window.initHomeMap?.());
      io.disconnect();
    }
  }, { rootMargin: '200px' });
  io.observe(homeMapSec);
}

// "Saltar al contenido": mueve el foco a <main> sin dejar #contenido en la URL.
document.querySelector('.skip-link')?.addEventListener('click', e => {
  e.preventDefault();
  const main = document.getElementById('contenido');
  if (!main) return;
  main.setAttribute('tabindex', '-1');
  main.focus();
});

/* ── Formulario de reservas → WhatsApp / correo ── */
const rvForm = document.getElementById('reservaForm');
if (rvForm) {
  const HOTEL_EMAIL = window.LG_CORREO; // lo arma correo.js (anti-spam)
  // Sin guiones opcionales (&shy;): el nombre neerlandés largo los lleva.
  const val = n => (rvForm.elements[n]?.value || '').replace(/­/g, '').trim();
  function buildMessage(){
    return [
      'Hola, quisiera consultar disponibilidad en Hotel La Gruta:',
      `Nombre: ${val('nombre')}`,
      `Teléfono: ${val('telefono')}`,
      val('correo') && `Correo: ${val('correo')}`,
      `Habitación: ${val('habitacion') || 'Sin preferencia'}`,
      `Huéspedes: ${val('huespedes') || '1'}`,
      `Llegada: ${val('llegada')}`,
      `Salida: ${val('salida')}`,
      val('mensaje') && `Mensaje: ${val('mensaje')}`,
    ].filter(Boolean).join('\n');
  }
  const note = document.getElementById('reservaNote');
  const tt = (k, fb) => (window.I18N && I18N.t(k) !== k) ? I18N.t(k) : fb;
  // Aviso de estado (región role="status"): se guarda la clave para
  // volver a traducirlo si cambia el idioma.
  function avisar(clave, fb){
    if (!note) return;
    note.dataset.clave = clave || '';
    note.textContent = clave ? tt(clave, fb) : '';
  }
  document.addEventListener('i18n:change', () => {
    if (note && note.dataset.clave) note.textContent = tt(note.dataset.clave, note.textContent);
    rvForm.querySelectorAll('.rv-error[data-clave]').forEach(el => { el.textContent = tt(el.dataset.clave, el.textContent); });
  });

  /* Fechas: la llegada no puede ser anterior a hoy y la salida va al menos un
     día después. Los límites viajan en `min` para que el calendario nativo y
     el selector propio (campos.js) también los respeten. */
  const iso = d => { const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000); return z.toISOString().slice(0, 10); };
  const hoy = () => iso(new Date());
  const diaSiguiente = s => { const d = new Date(s + 'T12:00:00'); d.setDate(d.getDate() + 1); return iso(d); };
  const llegada = rvForm.elements.llegada, salida = rvForm.elements.salida;
  function limitesFechas(){
    llegada.min = hoy();
    salida.min = diaSiguiente(llegada.value && llegada.value >= hoy() ? llegada.value : hoy());
  }
  limitesFechas();

  /* Errores en línea: texto traducido junto al campo, aria-invalid y
     aria-describedby. Sustituyen a los globos nativos del navegador, que salen
     en el idioma del sistema y no del sitio. */
  function marcar(campo, clave, fb){
    const caja = campo.closest('.rv-field');
    let err = caja.querySelector('.rv-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'rv-error';
      err.id = campo.id + '-error';
      caja.appendChild(err);
    }
    err.dataset.clave = clave;
    err.textContent = tt(clave, fb);
    campo.setAttribute('aria-invalid', 'true');
    campo.setAttribute('aria-describedby', err.id);
  }
  function limpiar(campo){
    campo.removeAttribute('aria-invalid');
    campo.removeAttribute('aria-describedby');
    campo.closest('.rv-field')?.querySelector('.rv-error')?.remove();
  }
  function validar(){
    const malos = [];
    const falla = (c, k, fb) => { if (!malos.includes(c)) { marcar(c, k, fb); malos.push(c); } };
    ['nombre', 'telefono', 'llegada', 'salida', 'correo'].forEach(n => limpiar(rvForm.elements[n]));
    ['nombre', 'telefono', 'llegada', 'salida'].forEach(n => {
      const c = rvForm.elements[n];
      if (!c.value.trim()) falla(c, 'rv.err.required', 'Completa este campo.');
    });
    const correo = rvForm.elements.correo;
    if (correo.value.trim() && !correo.checkValidity()) falla(correo, 'rv.err.email', 'Escribe un correo válido, por ejemplo nombre@correo.com.');
    if (llegada.value && llegada.value < hoy()) falla(llegada, 'rv.err.past', 'La llegada no puede ser anterior a hoy.');
    if (llegada.value && salida.value && salida.value <= llegada.value) falla(salida, 'rv.err.range', 'La salida debe ser posterior a la llegada.');
    if (malos.length) {
      avisar('rv.err.summary', 'Revisa los campos marcados para enviar tu consulta.');
      malos[0].focus();
      return false;
    }
    return true;
  }
  rvForm.addEventListener('input', e => {
    if (e.target.matches('[aria-invalid]')) limpiar(e.target);
    if (e.target === llegada) { limitesFechas(); if (salida.value && salida.value <= llegada.value) salida.value = ''; }
  });
  rvForm.addEventListener('change', e => { if (e.target === llegada) limitesFechas(); });

  rvForm.addEventListener('submit', e => {
    e.preventDefault();
    if (!validar()) return;
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(buildMessage())}`, '_blank');
    avisar('rv.note.wa', 'Se abrió WhatsApp con tu solicitud lista para enviar.');
  });
  document.getElementById('reservaMailto')?.addEventListener('click', e => {
    e.preventDefault();
    if (!validar()) return;
    const subject = encodeURIComponent(`Solicitud de reserva — ${val('nombre')}`);
    location.href = `mailto:${HOTEL_EMAIL}?subject=${subject}&body=${encodeURIComponent(buildMessage())}`;
    avisar('rv.note.mail', 'Se abrió tu cliente de correo con la solicitud lista para enviar.');
  });
}

/* ── Barra de disponibilidad del hero → consulta directa por WhatsApp ── */
document.querySelectorAll('.avail-btn').forEach(btn => {
  const box = btn.closest('.avail');
  const [checkin, checkout] = box.querySelectorAll('.avail-i');
  // Fechas coherentes: la llegada desde hoy y la salida desde el día siguiente
  // a la llegada (los calendarios nativo y propio respetan `min`).
  if (checkin && checkout) {
    const iso = d => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    const sumar = s => { const d = new Date(s + 'T12:00:00'); d.setDate(d.getDate() + 1); return iso(d); };
    const limites = () => {
      const hoy = iso(new Date());
      checkin.min = hoy;
      checkout.min = sumar(checkin.value && checkin.value >= hoy ? checkin.value : hoy);
      if (checkout.value && checkout.value < checkout.min) checkout.value = '';
    };
    limites();
    checkin.addEventListener('change', limites);
  }
  btn.addEventListener('click', () => {
    const guests = box.querySelector('.avail-s')?.value || '';
    const lines = [
      'Hola, quisiera consultar disponibilidad en Hotel La Gruta:',
      checkin?.value && `Llegada: ${checkin.value}`,
      checkout?.value && `Salida: ${checkout.value}`,
      guests && `Huéspedes: ${guests}`,
    ].filter(Boolean);
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank');
  });
});

/* ── Carrusel de fotos en las tarjetas de habitación ──
   Las flechitas ya existían (con hover), pero no hacían nada — no había
   más de una foto por habitación. Ahora que sí las hay (data-images, lista
   separada por comas en el mismo <img>), esto solo cambia el `src`: no
   hace falta montar varias <img> ni precargar nada de más. Las tarjetas
   sin data-images (Experiencias) no tienen flechas, así que no aplica.
   El cambio de foto usa Editorial Crossfade (foto-fundido.js). */
document.querySelectorAll('.room-card-arrow').forEach(arrow => {
  arrow.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    const img = arrow.closest('.room-card-media')?.querySelector('img');
    const list = img?.dataset.images?.split(',');
    if (!list || list.length < 2) return;
    const dir = arrow.textContent.trim() === '→' ? 1 : -1;
    // data-cur: el destino, incluso mientras carga o queda en cola durante
    // el fundido; los clics seguidos deben contar desde ese índice.
    const current = img.dataset.cur !== undefined ? +img.dataset.cur : list.indexOf(img.getAttribute('src'));
    const next = ((Math.max(0, current) + dir) % list.length + list.length) % list.length;
    img.dataset.cur = next;
    // Fundido editorial; sin el módulo, cambio directo.
    if (window.FotoFundido) window.FotoFundido.cambiar(img, list[next]);
    else img.src = list[next];
  });
});

/* ── Imágenes pendientes ──
   Varias fotos del hotel todavía no existen en el repo. En vez de repetir un
   data-URI gigante en cada <img> (eran ~14 KB de ruido dentro del HTML), se
   genera aquí el marcador a partir de `data-ph`.
   El listener va en fase de CAPTURA porque el evento `error` de <img> no
   burbujea; y además se repasan las que ya hubieran fallado antes de que este
   script llegara a ejecutarse. */
(function () {
  function esc(s) { return String(s).replace(/[&<>]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }

  function marcador(img) {
    if (img.dataset.phDone) return;
    img.dataset.phDone = '1';
    img.src = 'data:image/svg+xml;utf8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600">' +
        '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="#4A6146"/><stop offset="1" stop-color="#2E3E2B"/>' +
        '</linearGradient></defs>' +
        '<rect width="800" height="600" fill="url(#g)"/>' +
        '<text x="50%" y="50%" font-family="Georgia,serif" font-style="italic" font-size="46" ' +
              'fill="rgba(255,255,255,0.4)" text-anchor="middle" dominant-baseline="middle">' +
          esc(img.dataset.ph || '') +
        '</text>' +
      '</svg>');
  }

  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.dataset.ph) marcador(img);
  }, true);

  document.querySelectorAll('img[data-ph]').forEach(function (img) {
    if (img.complete && img.naturalWidth === 0) marcador(img);
  });
})();

/* ── Buscador de reservas: hint "dd/mm/aaaa" en los inputs de fecha ──
   Desktop lo muestra solo (el propio navegador dibuja ese texto dentro
   del widget nativo del input), pero Android Chrome e iOS Safari dejan
   el campo vacío sin ninguna pista y `placeholder` no existe para
   `input[type=date]`. Alterna `.is-empty` en `.avail-date` (ver
   site.css: el overlay `.avail-ph` solo se pinta dentro del media query
   móvil, así que esto no afecta nada en desktop). */
(function () {
  document.querySelectorAll('.avail-date').forEach(function (wrap) {
    var input = wrap.querySelector('.avail-i');
    if (!input) return;
    function sync() { wrap.classList.toggle('is-empty', !input.value); }
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  });
})();

(function () {
  document.querySelectorAll('.reviews-track-wrap').forEach(function (wrap) {
    var track = wrap.querySelector('.reviews-track');
    var arrow = wrap.querySelector('.reviews-arrow');
    if (!track || !arrow) return;
    var reducido = matchMedia('(prefers-reduced-motion: reduce)');
    arrow.hidden = true;
    function actualizarControl() {
      if (!wrap.clientWidth) return; // Inicio puede estar oculto al entrar en otra página.
      // Con el carrusel automático (opiniones-carrusel.js) no hay flecha.
      if (wrap.classList.contains('is-carrusel')) { arrow.hidden = true; track.tabIndex = -1; return; }
      var cards = track.querySelectorAll('.review-card');
      var estilo = getComputedStyle(track), marco = getComputedStyle(wrap);
      var padding = (parseFloat(estilo.paddingLeft) || 0) + (parseFloat(estilo.paddingRight) || 0);
      // Medir la fila natural, sin los transforms de la baraja ni el espacio
      // que ocuparía la flecha. Así no parpadea cerca del límite de encaje.
      var contenido = cards.length ? cards[cards.length - 1].offsetLeft - cards[0].offsetLeft + cards[cards.length - 1].offsetWidth + padding : 0;
      var disponible = wrap.clientWidth - (parseFloat(marco.paddingLeft) || 0) - (parseFloat(marco.paddingRight) || 0);
      var necesario = contenido > disponible + 1;
      track.tabIndex = necesario ? 0 : -1;
      if (!necesario && document.activeElement === arrow) track.focus({ preventScroll: true });
      arrow.hidden = !necesario;
      if (!necesario && track.scrollLeft) track.scrollTo({ left: 0, behavior: 'instant' });
    }
    actualizarControl();
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(actualizarControl);
      observer.observe(wrap);
      observer.observe(track);
      track.querySelectorAll('.review-card').forEach(function (card) { observer.observe(card); });
    }
    window.addEventListener('resize', actualizarControl);
    document.addEventListener('i18n:change', actualizarControl);
    if (document.fonts) document.fonts.ready.then(actualizarControl);
    arrow.addEventListener('click', function (e) {
      if (arrow.hidden) return;
      var card = track.querySelector('.review-card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = card ? card.offsetWidth + gap : track.clientWidth;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step,
        behavior: reducido.matches || e.detail === 0 ? 'instant' : 'smooth' });
    });
  });
})();

/* ── Modal "Ver más" de habitación ──
   Un solo modal en todo el documento, rellenado al vuelo con los datos de
   la .room-card sobre la que se hizo click: nombre, lista de fotos
   (data-images, la misma que ya usa el carrusel de la tarjeta) y el texto
   largo. Nombre y descripción corta se leen del propio DOM de la tarjeta
   (.room-card-name/.room-card-desc), que i18n.js ya tradujo al idioma
   activo — no hace falta lógica extra ahí. El texto LARGO no vive en el
   DOM como texto visible (antes era el atributo `data-detail`, texto
   plano en español); ahora la tarjeta lleva `data-detail-key` con la
   clave del diccionario y se resuelve acá con I18N.t() al abrir el modal,
   para que también salga en el idioma activo. Si la tarjeta no trae la
   clave (o I18N no cargó por algún motivo), cae al .room-card-desc corto
   — así ninguna tarjeta futura rompe el modal por no traer el atributo.
   El scroll-lock del body reutiliza el mismo truco de position:fixed que
   setMenuOpen() en vez de overflow:hidden a secas, por el mismo motivo
   (rebote de iOS Safari, ver ese comentario). */
(function () {
  var modal = document.getElementById('roomModal');
  if (!modal) return;
  var img = modal.querySelector('.room-modal-img');
  var nameEl = modal.querySelector('.room-modal-name');
  var descEl = modal.querySelector('.room-modal-desc');
  var dotsEl = modal.querySelector('.room-modal-dots');
  var arrows = modal.querySelectorAll('.room-modal-arrow');
  var images = [];
  var current = 0;
  var modalScrollY = 0;
  var lastCard = null;
  var opener = null;

  var guestsEl = modal.querySelector('.room-modal-guests');
  var waEl = modal.querySelector('.room-modal-wa');
  function T(key, fallback) { return (window.I18N && window.I18N.t(key)) || fallback; }

  /* Datos propios de cada habitación, leídos de la tarjeta (index.html):
       data-guests="2"          → "2 huéspedes" (reutiliza avail.guest1..3). Si la
                                  tarjeta no lo trae, la línea no se muestra: es
                                  preferible a inventar una capacidad.
     El enlace de WhatsApp lleva el nombre de la habitación y el mensaje va en el
     idioma activo (clave modal.waMsg). Se vuelve a pintar al cambiar de idioma. */
  function renderFacts(card) {
    var n = parseInt(card.dataset.guests, 10);
    guestsEl.hidden = !n;
    if (n) guestsEl.querySelector('span').textContent = T('avail.guest' + Math.min(n, 4), n + '');
    var msg = T('modal.waMsg', '').replace('{room}', nameEl.textContent.replace(/­/g, ''));
    waEl.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function renderText(card) {
    nameEl.textContent = card.querySelector('.room-card-name')?.textContent || '';
    var detailKey = card.dataset.detailKey;
    descEl.textContent = (detailKey && window.I18N)
      ? window.I18N.t(detailKey)
      : (card.querySelector('.room-card-desc')?.textContent || '');
    renderFacts(card);
  }

  function renderDots() {
    dotsEl.innerHTML = '';
    if (images.length < 2) return;
    images.forEach(function (_, i) {
      var dot = document.createElement('span');
      dot.className = 'room-modal-dot' + (i === current ? ' on' : '');
      dotsEl.appendChild(dot);
    });
  }

  // dir: con las flechas, la foto cambia con el fundido editorial
  // (foto-fundido.js); al abrir el modal se pone directa y se descarta
  // cualquier fundido pendiente de la habitación anterior.
  function showImage(i, dir) {
    if (!images.length) return;
    current = ((i % images.length) + images.length) % images.length;
    if (!window.FotoFundido) img.src = images[current];
    else if (dir) window.FotoFundido.cambiar(img, images[current]);
    else window.FotoFundido.fijar(img, images[current]);
    renderDots();
  }

  function openModal(card) {
    lastCard = card;
    // La ficha de un tipo (catálogo, habitaciones.js) trae su galería en
    // data-images; una habitación o una tarjeta del Inicio, en su <img>.
    var mediaImg = card.querySelector('.room-card-media img');
    images = (card.dataset.images || mediaImg?.dataset.images || mediaImg?.src || '').split(',').filter(Boolean);
    img.alt = card.querySelector('.room-card-name')?.textContent || '';
    img.dataset.ph = mediaImg?.dataset.ph || '';
    renderText(card);
    var arrowsWrap = modal.querySelector('.room-modal-arrows');
    arrowsWrap.style.display = images.length > 1 ? '' : 'none';
    // Abre en la foto que se estaba viendo en la tarjeta (carrusel del catálogo).
    showImage(Math.max(0, images.indexOf(mediaImg?.getAttribute('src'))));

    // Quién lo abrió, para devolverle el foco al cerrar (teclado y lectores).
    opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('on');
      // El foco entra al diálogo: sin esto, Tab seguía recorriendo la página de atrás.
      var cerrar = modal.querySelector('.room-modal-close');
      if (cerrar) cerrar.focus({ preventScroll: true });
    });
    modalScrollY = window.scrollY;
    document.body.classList.add('modal-lock');
    document.body.style.top = (-modalScrollY) + 'px';
  }

  function closeModal() {
    modal.classList.remove('on');
    document.body.classList.remove('modal-lock');
    document.body.style.top = '';
    window.scrollTo({ top: modalScrollY, left: 0, behavior: 'instant' });
    setTimeout(function () { modal.hidden = true; }, 250);
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }

  // Tab y Shift+Tab giran dentro del diálogo mientras está abierto.
  function enfocables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || modal.hidden) return;
    var lista = enfocables();
    if (!lista.length) return;
    var primero = lista[0], ultimo = lista[lista.length - 1];
    if (!modal.contains(document.activeElement)) { e.preventDefault(); primero.focus(); }
    else if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  // "Ver más" de las tarjetas del Inicio (data-room="suite"…): abre la ficha
  // de ESA habitación ahí mismo. Habitaciones es otra página, así que la
  // ficha se arma con lo mismo que usa su catálogo (habitaciones-data.js):
  // nombre, capacidad y todas las fotos del tipo. Sin datos, el enlace
  // lleva a Habitaciones (su href).
  function fichaDeTipo(id) {
    var tp = (window.LG_HABITACIONES || []).filter(function (x) { return x.id === id; })[0];
    if (!tp) return null;
    var fotos = [];
    tp.unidades.forEach(function (u) { u.fotos.forEach(function (f) { if (fotos.indexOf(f) === -1) fotos.push(f); }); });
    var ficha = document.createElement('div');
    ficha.dataset.detailKey = 'rooms.' + id + '.detail';
    if (tp.huespedes) ficha.dataset.guests = tp.huespedes;
    ficha.dataset.images = fotos.join(',');
    var nombre = document.createElement('span');
    nombre.className = 'room-card-name';
    nombre.textContent = T('rooms.' + id + '.name', id);
    ficha.appendChild(nombre);
    return ficha;
  }
  document.querySelectorAll('.rc-more[data-room]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var ficha = fichaDeTipo(link.dataset.room);
      if (!ficha) return;
      e.preventDefault();
      openModal(ficha);
    });
  });

  // "Ver más" de un tipo y "Ver fotos" de una habitación del catálogo. Por
  // delegación: el catálogo lo arma habitaciones.js y puede cambiar.
  document.addEventListener('click', function (e) {
    // En el catálogo, tocar la foto también abre la galería (no las flechas).
    var link = e.target.closest('.room-more, .hab-ver, .hab-fotos') || (e.target.matches('.hab-media img') && e.target);
    if (!link) return;
    var card = link.closest('.hab-unidad, .room-card');
    if (!card) return;
    e.preventDefault();
    openModal(card);
  });

  // La foto de la tarjeta de habitación (Inicio y Habitaciones) abre la misma ficha que su
  // enlace «Ver fotos» / «Fotos y detalles». Se ignoran los enlaces y botones que haya dentro
  // de la foto (p. ej. la etiqueta de cantidad), que conservan su función.
  document.addEventListener('click', function (e) {
    var foto = e.target.closest && e.target.closest('.rd-hab-foto');
    if (!foto || e.target.closest('a, button')) return;
    var inc = foto.closest('.rd-hab-inc');
    var boton = inc && inc.querySelector('.rd-hab-fotos, .room-more');
    if (!boton) return;
    e.preventDefault();
    boton.click();
  });

  modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  arrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () { showImage(current + Number(arrow.dataset.dir), Number(arrow.dataset.dir)); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
  modal.querySelector('.room-modal-book')?.addEventListener('click', closeModal);

  // Si el idioma cambia con el modal abierto, refresca nombre/descripción
  // (las amenities ya se actualizan solas: son data-i18n normales, i18n.js
  // las recorre a todas sin importar si el modal está abierto o cerrado).
  document.addEventListener('i18n:change', function () {
    if (!modal.hidden && lastCard) renderText(lastCard);
  });
})();
